// タイル型の contentGroups を「行(tileRow)昇順→行内は列(tileCol)昇順」の閲覧順に並べ替える。
// 行またぎのスワイプ/矢印ナビゲーションや自動送りはこの配列順を辿るため、
// icons.js の generateTileRows が作る見た目のグリッド（(tileRow, tileCol)昇順でソートしてから
// tileColumns件ずつ詰め直す）と一致させる必要がある。tileCol まで見ないと、同じ行内でAPIの
// 返却順がグリッドの左→右と食い違った場合にナビゲーション順だけがバラバラになる。
export const sortContentGroupsForTileReadingOrder = (contentGroups) => {
  if (!Array.isArray(contentGroups)) return [];
  const getTileRow = (group) => Number(group?.tileRow ?? group?.tile_row ?? 0);
  const getTileCol = (group) => Number(group?.tileCol ?? group?.tile_col ?? 0);
  return [...contentGroups].sort((a, b) => (
    getTileRow(a) - getTileRow(b) || getTileCol(a) - getTileCol(b)
  ));
};
